export default __webpack_public_path__ + "static/media/metrics-participants.4d97db47.svg";